import React from 'react';

import { TextInput } from '@components/admin/Forms';
import {
  ManagementBaseProps,
  ManagementLabel,
  useManagementFormStyles,
} from '@components/Forms/managementCommon';
import { TextInputProps } from '@components/Forms/TextInput';
import { SemiAutoCompleteOption } from '@components/TextBox';
import { useCommonStyles } from '@styles';

export interface ManagementTextInputProps extends TextInputProps, ManagementBaseProps {
  type?: string;
  name: string;
  placeholder?: string;
  multiline?: boolean;
  withAutoComplete?: boolean;
  autoCompleteChoices?: string[];
  autoComplete?: string;
  withSemiAutoComplete?: boolean;
  semiAutoCompleteOptions?: SemiAutoCompleteOption[];
  onSemiAutoCompleteOptionSelect?: (option: SemiAutoCompleteOption) => void;
}

export const ManagementTextInput: React.FC<ManagementTextInputProps> = (props) => {
  const {
    type,
    name,
    placeholder = '',
    disabled = false,
    multiline = false,
    withAutoComplete = false,
    autoCompleteChoices,
    autoComplete,
    withSemiAutoComplete,
    semiAutoCompleteOptions,
    onSemiAutoCompleteOptionSelect,
    ...rest
  } = props;

  const classes = {
    ...useCommonStyles(),
    ...useManagementFormStyles(),
  };

  return (
    <div className={classes.container}>
      <TextInput
        name={name}
        label={<ManagementLabel {...props} />}
        formClasses={{
          label: classes.label,
        }}
        classes={{
          textInput: classes.textInput,
        }}
        placeholder={placeholder}
        type={type}
        disabled={disabled}
        multiline={multiline}
        withAutoComplete={withAutoComplete}
        autoCompleteChoices={autoCompleteChoices}
        autoComplete={autoComplete}
        withSemiAutoComplete={withSemiAutoComplete}
        semiAutoCompleteOptions={semiAutoCompleteOptions}
        onSemiAutoCompleteOptionSelect={onSemiAutoCompleteOptionSelect}
        {...rest}
      />
    </div>
  );
};
